
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/user-feature-matrix",
      function () {
        return require("private-next-pages/ai-decisioning/user-feature-matrix.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/user-feature-matrix"])
      });
    }
  